export default __webpack_public_path__ + "static/friend_02-d326543a00475250856d502fba51e691.png";